module.exports = __webpack_public_path__ + "static/media/Rubik-Regular.35af6dbe.ttf";